import { nanoid } from 'nanoid/non-secure';
import type { AppDefinition } from '@/types/app';

export function createDefaultAppDefinition(name: string): AppDefinition {
  return {
    id: nanoid(),
    name,
    description: '',
    version: '1.0.0',
    theme: {
      colors: {
        primary: '#007AFF',
        secondary: '#5856D6',
        background: '#F2F2F7',
        surface: '#FFFFFF',
        text: '#000000',
        textSecondary: '#8E8E93',
        error: '#FF3B30',
        success: '#34C759',
        warning: '#FF9500',
        border: '#C6C6C8',
      },
      spacing: { xs: 4, sm: 8, md: 16, lg: 24, xl: 32 },
      borderRadius: { sm: 4, md: 8, lg: 16, full: 9999 },
      typography: {
        h1: { fontSize: 34, fontWeight: '700' },
        h2: { fontSize: 28, fontWeight: '700' },
        h3: { fontSize: 22, fontWeight: '600' },
        h4: { fontSize: 20, fontWeight: '600' },
        h5: { fontSize: 17, fontWeight: '600' },
        h6: { fontSize: 15, fontWeight: '600' },
        body: { fontSize: 17, fontWeight: '400' },
        caption: { fontSize: 12, fontWeight: '400' },
      },
    },
    screens: [
      {
        id: nanoid(),
        name: 'Home',
        title: 'Home',
        components: [
          {
            id: nanoid(),
            type: 'text',
            props: { text: `Welcome to ${name}`, variant: 'h2' },
          },
        ],
      },
    ],
    schemas: [],
    navigation: {
      type: 'stack',
      screens: [],
    },
  };
}
